import React from 'react';
import Progress from '../../../components/progress';
import Score from '../../../components/score';
import '../../results/index.scss';
import coupleLaughing from "../../../images/parent-and-child-with-physician.jpg";
import personLaughing from "../../../images/person-smiling-at-phone.jpg";
import poorlyControlled from "../../../images/poorly-controlled-asthma-scale-background-kids.svg";
import controlled from "../../../images/well-controlled-asthma-scale-background-kids.svg"
import questionMarks from "../../../images/asthma-control-test-results.svg"

const Results = (props) => {
    const container = document.querySelector(".act-container");
    if (container) {
        container.classList.add("results");
    }
    return (
        <div className="screen results">
            <section>
                <div className="content-container">
                    <div className="col-xs-12 col-md-8 col-md-offset-2">
                        <img className="imgCenter resultsBubbles" src={questionMarks} alt="Asthma Control Test Results" />
                        <h2 className="header2 center">Your Childhood Asthma Control Test Results</h2>
                    </div>
                </div>
            </section>
            <section className="actResults">
                <div className="content-container">
                    <div className="col-xs-12 col-md-3 col-md-offset-2">
                        <p className="quote center"><span className="stat">Your child's score is:</span></p>
                        <Score Score={props.Score} Results={true} />
                        <div className="restrict">
                            <p className="base-copy center"><strong className="txt-tango">0-19</strong><br />Your child's asthma symptoms may not be well controlled <br /><br /></p>
                            <p className="base-copy center"><strong className="txt-eastern-blue">20-27</strong><br />Your child's asthma symptoms may be well controlled<br /><br /></p>
                        </div>
                        <p className="base-copy center"><b>No matter what your child's score is, share the results with your child's healthcare provider.</b></p>
                    </div>
                    <div className="col-xs-12 col-md-5">
                        <p className="base-copy"><b>If your score is 19 or less,</b></p>
                        <h3 className="header3 "><span className="txt-pickled-bluewood">Your child's asthma symptoms may not be as well controlled as they could be.</span></h3>
                        <p className="base-copy">NOTE: If your child's score is 12 or less, your asthma may be very poorly controlled. Please contact your child's healthcare provider right away.</p><br />
                        <p className="base-copy">There may be more you and your child's healthcare provider could do to help control your child's asthma symptoms.</p>
                        <Progress Score={props.Score} role={props.role} />
                        <button type="button" className="btn cta3" onClick={props.printHandler}>Print Your Results</button>
                    </div>
                </div>
            </section>

            <section>
                <div className="content-container">
                    <div className="col-xs-12 col-md-7 col-md-offset-2">
                        <dl className="reminder ttyd">
                            <dt><h6 className="header6">Bring This Test to Your Child's Healthcare Provider to Talk About The Results</h6></dt>
                            <dd><p className="base-copy">Now is a good time to make an appointment with your child's healthcare provider to discuss your child's score and ask about possible changes that may be needed in managing his or her asthma.</p></dd>
                        </dl>
                        <dl className="reminder habit">
                            <dt><h6 className="header6">Make Testing a Habit</h6></dt>
                            <dd><p className="base-copy">Remember, your child's asthma may change over time. Be sure to have your child take this test periodically, and work closely with your child's healthcare provider to monitor your child's level of asthma symptom control.</p></dd>
                        </dl>
                    </div>
                </div>
            </section>
            <section className="spectrum">
                <div className="content-container">
                    <div className="col-xs-12 col-md-8 col-md-offset-2">
                        <h2 className="header2 center">The Asthma Control Spectrum</h2>
                    </div>
                </div>
                <div className="content-container act-cards">
                    <div className="act-card col-xs-12 col-md-4 col-md-offset-2">
                        <div className="poorlyCard">
                            <div className="cardImage"><img src={poorlyControlled} alt="Scores Between 0 and 19 May Indicate Poorly-Controlled Asthma" /></div>
                            <p className="quote">Your child's asthma symptoms may not be well controlled</p>
                            <p className="base-copy">Scores between 0 - 19 indicate that your child's asthma may not be well controlled. You should share these results with your child's doctor right away to have a conversation about how to better manage your child’s asthma.</p>
                        </div>
                    </div>
                    <div className="act-card col-xs-12 col-md-4">
                        <div className="controlledCard">
                            <div className="cardImage"><img src={controlled} alt="Scores Between 20 and 27 May Indicate Well-Controlled Asthma" /></div>
                            <p className="quote">Your child's asthma symptoms may be well controlled</p>
                            <p className="base-copy">Scores between 20 - 27 indicate that your child's asthma may be well controlled. Be sure to share these results with your child's doctor to discuss what else you can do to get even better control over your child's symptoms.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="content-container">
                    <div className="col-xs-12 col-md-8 col-md-offset-2">
                        <h2 className="header2 center">Additional Asthma Control Resources</h2>
                    </div>
                </div>
                <div className="content-container" id="resources">
                    <div className="col-xs-12 col-md-4 col-md-offset-2">
                        <a className="resources" href="/understanding-asthma/severe-asthma/">
                            <div className="mask">
                                <img src={coupleLaughing} width="100%" alt="Couple Laughing" />
                            </div>
                            <h6 className="header6">Severe Asthma vs Asthma Control</h6>
                            <p className="base-copy">Severe asthma is often uncontrolled, but uncontrolled asthma is not the same as severe asthma. Find out more about the different types of severe asthma.</p>
                            <p className="base-copy"><span className="cta4">Learn The Difference</span></p>
                        </a>
                    </div>
                    <div className="col-xs-12 col-md-4 specialistResource">
                        <a className="resources" href="/treating-asthma/asthma-specialist/">
                            <div className="mask">
                                <img src={personLaughing} width="100%" alt="Person Smiling at Phone" />
                            </div>
                            <h6 className="header6">Find an Asthma Specialist</h6>
                            <p className="base-copy">An asthma specialist can help you determine whether your asthma is controlled and help you create an Asthma Action Plan to help manage it.</p>
                            <p className="base-copy"><span className="cta4">Find a Specialist </span></p>
                        </a>
                    </div>
                </div>
            </section>
            <section className="bottomHero">
                <div className="content-container">
                    <div className="col-xs-12 col-md-5 col-md-offset-1">
                        <h2 className="header2">Understand Your Asthma Triggers</h2>
                        <p className="base-copy">Identifying and managing your asthma triggers can lead to better asthma symptom control.</p>
                        <p className="base-copy"><a className="btn cta1" href="/understanding-asthma/asthma-triggers/">What Triggers Asthma?</a></p>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Results;
